<template lang="pug">
.building-storage
  .level {{ upgradable ? info.config.level : 'max' }}
  .stores(v-for="(item) in storage").p-2
    Icon(size="md" :item="item.name")
    VerticalStorage(
      :max="item.max"
      :current="item.current"
      :key="item.name"
    )
</template>

<script>
import Counter from '@/components/buildings/common/Counter'
import VerticalStorage from '@/components/buildings/common/VerticalStorage'

export default {
  props: [ 'info' ],
  components: { Counter, VerticalStorage },
  computed: {
    storage () {
      return Object.keys(this.info.config.stores).map(name => ({
        name: name,
        current: this.info.contains[name],
        max: this.info.config.stores[name]
      }))
    },
    upgradable () {
      return this.info.config.level < this.info.config.levelMax
    }
  },
  methods: {
    format (number) {
      if (number > 10000) {
        return Math.floor(number / 1000) + 'k'
      }

      if (number > 1000) {
        return Math.floor(number / 1000) + '.' + ('' + number % 1000).padStart(3, 0)
      }

      return number
    }
  }
}
</script>

<style lang="scss" scoped>
.level {
  position: absolute;
  right: 4px;
  top: 0;
  line-height: 18px;
  width: 20px;
  text-align: right;
  font-size: 12px;

.building-storage {
  position: relative;
  background-color: #eeddda;
  line-height: 85px;
  font-size: 12px;

}
}</style>



// WEBPACK FOOTER //
// src/components/buildings/Storage.vue